import {
    useTypedSelector
} from "@Store/@Hooks";

import {
    QyvoUserModel
} from "@Models/Users";


export const UseQyvoUser = () : QyvoUserModel | null => {

    const {
        QyvoUser
    } = useTypedSelector((state) => state.authentication);

    return QyvoUser || null;

};


export default UseQyvoUser;

